<template>
  <div>
    <DialogCheckbox
      v-model="show"
      :data="data.columns"
      dialogIcon="mdi-table-arrow-down"
      title="Kolonner som skal eksporteres"
      @action="exportTable"
    >
    </DialogCheckbox>
  </div>
</template>

<script>
import exportApi from "@/api/exportApi";
import moment from "moment";
import saveFile from "@/helpers/saveFile.ts";
import DialogCheckbox from "@/components/shared/dialog/DialogCheckbox";
export default {
  props: {
    value: {
      required: true,
    },
    headers: {},
    items: {},
    color: {
      default: "success",
    },
    exportName: {
      default: null,
    },
    removeExportButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: { columns: [], footer: [], rows: [] },
      showDialog: false,
    };
  },
  methods: {
    openDialog() {
      this.data.columns = [];
      var columns = [];
      this.headers.forEach((x) => {
        //cant eksport edit row
        if (x.type !== "edit") {
          x.breakText = x.breakText ? x.breakText : false;
          x.dataKey = x.value;
          x.exportCol = x.show;
          x.name = x.text;

          if (x.removeFromExport != true) {
            columns.push(x);
          }
        }
      });
      this.data.columns = JSON.parse(JSON.stringify(columns));
      this.showDialog = true;
    },
    exportTable() {
      this.getRows();
      this.getExport();
    },
    exportAll() {
      var dateToDay = moment().format("DD-MM-YYYY HH:mm");
      this.data.FileName = `${this.exportName} - ${dateToDay}`;
      this.$emit("exportAll", this.data);
      this.show = false;
    },
    async getExport() {
      var dateToDay = moment().format("DD-MM-YYYY HH:mm");
      this.data.FileName = `${this.exportName} - ${dateToDay}`;
      await exportApi.exportTable(this.data).then((Response) => {
        saveFile(Response, this.data.FileName);
      });
    },

    getRows() {
      this.data.rows = [];
      this.items.forEach((r) => {
        var er = {
          values: [],
        };

        this.data.columns.forEach((c) => {
          if (c.exportCol) {
            er.values.push({
              key: c.name,
              value: r[c.dataKey],
            });
          }
        });
        this.data.rows.push(er);
      });
    },
  },
  computed: {
    show: {
      get: function () {
        if (this.value) {
          this.openDialog();
        }
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    DialogCheckbox,
  },
};
</script>
